
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M44.047 14.81c-1.08-1.08-1.08-4.78-1.08-5.62 0-.84-.36-1.19-1-1.19h-23.89c-.64 0-1 .36-1 1.19s0 4.54-1.08 5.62c0 1.55-1.91 35.22-1.99 36.29-.08 1.06.53 1.33 1.7 1.33h28.63c1.17 0 1.78-.27 1.7-1.33-.08-1.06-1.99-34.73-1.99-36.29zm-29.32-.04h30.6"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M15.187 30.42c5.52 0 6.23 2.51 10.14 2.51s5.66-2.51 10.08-2.51 6.13 2.51 9.6 2.51m-12.79 7.37a2.12 2.12 0 100-4.24 2.12 2.12 0 000 4.24zm-10.85 0a1.53 1.53 0 100-3.06 1.53 1.53 0 000 3.06zm2.55 8.18a2.21 2.21 0 100-4.42 2.21 2.21 0 000 4.42zm14.24.39a2.81 2.81 0 100-5.62 2.81 2.81 0 000 5.62z"}})])
          )
        }
      }
    